import { Box } from '@mui/material';
import { Theme, styled } from '@mui/material/styles';

// Outlined like a small text field, so the row reads as "file name" + "Select File".
export const StyledFileBox = styled(Box)(({ theme }: { theme: Theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '260px',
  height: '40px',
  border: `1px solid ${theme.palette.grey[400]}`,
  borderRadius: '8px',
  padding: '0 4px 0 8px',
  cursor: 'pointer',
  '&:hover': { backgroundColor: theme.palette.action.hover },
}));
